<!--suppress ALL -->
<template>
  <div id="login" @keyup.enter="keyCodeLogin">
    <div class="box">
      <p class="tip">28管理后台</p>
      <el-form id="loginForm" ref="loginForm" :model="loginForm" :rules="loginRule">
        <el-form-item class="input"  prop="username" style="margin-top: .6rem">
          <el-input size="large" v-model="loginForm.username" placeholder="请输入用户名" >
            <i slot="prefix" class="iconfont icondaogouyuanx" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="input" prop="password" >
          <el-input size="large" v-model="loginForm.password" type="password" placeholder="请输入密码" >
            <i slot="prefix" class="iconfont iconmimax" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-button class="btn1" type="primary" @click="presubmit">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      centerDialogVisible: false,
      alertOpenIng: false,
      vcodeurl: '',
      loading: true,
      loginForm:{
        username: null,
        password: null
      },
      loginRule: {
        username: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
	getDomain () {
	  let url = location.href
	  url = url.replace('https://', '')
	  url = url.replace('http://', '')
	  url = url.split('/')[0]?url.split('/')[0]:url
	  url = url.replace('www.', '')
	  let website = 1
	  switch (url) {
		  case '16b.in':
			website = 2
			break
		  case '18b.in':
			website = 3
			break
		  case '11b.in':
			website = 1
			break
		  case 'dzpc28.cc':
			website = 4
			break
		  case 'hjpc28.cc':
			website = 5
			break
		  case 'hxpc28.cc':
			website = 6
			break
		  case '8812.co':
			website = 7
			break
		  case 'zspc28.cc':
			website = 8
			break
		  case 'kkjnd.com':
			website = 14
			break
		  case '88377.app':
			website = 18
			break
		  default:
			website = 18
			break
	  }
	  return website
	},
    presubmit () {
      let _this = this
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          _this.submit()
        } else {
          console.log('error!')
          return false;
        }
      })
    },
    submit () {
      let _this = this
      this.loginForm.code_token = -1
	  this.loginForm.webid = this.getDomain()
	  localStorage.clear()
      this.axios({
        method: 'post',
        url: '/kaiSrv/auth/login',
        data: this.loginForm
      })
        .then(function (res) {
          console.log(res)
          if (res.data.code !== 0) {
            _this.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            })
          } else {
            _this.unSetLocalStorage()
            localStorage.loginAccount = _this.loginForm.username
            localStorage.access_token = res.data.access_token
            localStorage.webid = res.data.webid
            _this.$router.push("/kaimgr/home")
          }
        })
        .catch(function (err) {
		  if (err.msg) {
            _this.$alert(err.msg, '提示', {
              confirmButtonText: '确定'
            })
          } else {
            _this.$alert('网络异常，请重试', '提示', {
              confirmButtonText: '确定'
            })
          }
          
        })
    },
    keyCodeLogin () {
      this.presubmit()
    }
  }
}
</script>

<style lang="scss">
  #login {
    .el-input__inner{
      height: 0.416rem;
      border: none;
      border-bottom: 1px solid #ccc;
      border-radius: 0;
      padding-left: 0.3rem;
    }
    .el-dialog__body{
      height: 130px;
      padding: 0px 20px 20px;
    }
    .el-dialog__wrapper {
      position: absolute;
      top: -0.08rem;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 0.28rem;
    }
  }
</style>

<style scoped lang="scss">
#login {
  display: inline-block;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  .box {
    position: absolute;
    width: 3.6rem;
    height: calc(3rem + 1.667rem);
    background-color: #fff;
    border-radius: .05rem;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .tip {
      margin-top: .49rem;
      font-size: 0.25rem;
      letter-spacing: 0.051rem;
      color: #000000;
      text-align: center;
    }
    .input {
      width: 3.0rem;
      height: 0.416rem;
      margin: 0.25rem auto;
      color: #bfbfbf;
      .iconfont{
        line-height: 0.416rem;
      }
    }
    .input1 {
      margin: .63rem auto 0;
    }

    .forget {
      color: #666666;
      float: right;
      margin: 0 .25rem 0 0;
      font-size: .12rem;
      cursor: pointer;
    }
    .forget:hover,.register:hover{
      text-decoration: none;
      color: #333;
    }
    #divblock{
      clear: both;
      display: block;
      width: 3.5rem;
      margin: 0.04rem auto 0;
      padding-top: 0.08rem;
      iframe{
        border:none;
        padding:0px;
        margin:0px;
        width:257px;
        height:128px;
      }
    }
    .btn1 {
      width: 3.02rem;
      height: 0.416rem;
      margin: .19rem auto 0.167rem .3rem;
      color: #fff;
      text-align: center;
      font-size: 0.167rem;
      background-color: #000000;
      border: none;
    }
    .register {
      span{
        cursor: pointer;
      }
      color: #666666;
      text-align: left;
      font-size: .12rem;
      padding-left: 0.3rem;
      margin-top: 0.1rem;
    }
    .register i{
      margin-left: .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue